<template>
  <div class="container min-vh-100">
    <div class="row min-vh-100">
      <div class="col-md-4 m-auto">
        <section class="row">
          <div class="col-12">
            <img
              src="/img/logo.jpg"
              class="img-logo img-responsive mb-3"
              alt="logo"
            />
            <h5 class="text-center text-muted login">CBA Sucre</h5>
            <div
              class="alert alert-danger"
              role="alert"
              v-if="messageError != ''"
            >
              <strong>{{ messageError }}</strong>
            </div>
          </div>
        </section>
        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="login">
            <section class="row">
              <div class="col-12">
                <div class="form-group">
                  <ValidationProvider
                    name="username"
                    rules="required|max:60"
                    :debounce="500"
                    v-slot="{ valid, errors }"
                  >
                    <label for="username" class="col-form-label text-md-right"
                      >Usuario</label
                    >
                    <input
                      v-model="user.username"
                      autofocus
                      type="text"
                      placeholder="Usuario"
                      class="form-control"
                      maxlength="60"
                    />
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
            </section>
            <section class="row">
              <div class="col-12">
                <div class="form-group">
                  <ValidationProvider
                    name="password"
                    rules="required|min:6|max:60"
                    v-slot="{ valid, errors }"
                  >
                    <label for="password" class="col-form-label text-md-right"
                      >Contraseña</label
                    >
                    <input
                      v-model="user.password"
                      type="password"
                      placeholder="Contraseña"
                      class="form-control"
                      maxlength="60"
                    />
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
            </section>

            <div class="form-group row">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-block btn-primary"
                  variant="success"
                  :disabled="invalid || addLoader"
                >
                  <span v-if="!addLoader">Iniciar Sesión </span>
                  <span v-if="addLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <div class="row">
          <div class="col">
            <router-link
              to="/recuperar-contrasena"
              custom
              v-slot="{ href, navigate }"
            >
              <a :href="href" class="btn btn-link" @click="navigate">
                ¿Has olvidado tu contraseña?
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInvalidFeedback } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, email, max, min } from "vee-validate/dist/rules";
import Auth from "@/plugins/services/auth";

export default {
  name: "Login",
  components: { BFormInvalidFeedback },
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      messageError: "",
      addLoader: false,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido.",
    });

    extend("email", {
      ...email,
      message: "El email tiene un formato incorrecto.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("min", {
      ...min,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como mínimo.",
    });
  },
  methods: {
    login() {
      this.addLoader = true;
      this.messageError = "";
      Auth.csrf(this.user)
        .then((res) => {
          Auth.login(this.user)
            .then((res) => {
              this.messageError = "";
              this.addLoader = false;
              let user = res.data;
              this.$store.commit("set", ["userAuth", user]);
              this.$router.replace("/dashboard");
            })
            .catch((err) => {
              this.addLoader = false;
              if (err.response && err.response.status == 422) {
                this.messageError = err.response.data.errors.username[0];
              }
              if (err.response && err.response.status == 403) {
                this.messageError = err.response.data.errors.enabled;
              }
              if (err.response && err.response.status == 429) {
                this.messageError = err.response.data.errors.username[0];
              }
              if (err.response && err.response.status == 500) {
                this.messageError = "Error 500.";
              }
              this.$store.commit("set", ["userAuth", null]);
            });
        })
        .catch((err) => {
          Utils.setFlash("danger", "Error " + err);
        });
    },
  },
};
</script>
